module.exports = __webpack_public_path__ + "img/vertical-logo-pink-th.e981c2b8.svg";